import React from 'react';

export default function InitialsBubble({ preview, text }: { preview: boolean, text: string }) {
  return (
    <div className={`${preview ? 'preview' : 'initials'}-bubble avatar avatar-lg`}>
      <div className="text">{text}</div>
    </div>
  );
}
